import React, { Component } from 'react'
import Edit from '../assets/edit.svg'
import {OverlayTrigger,Tooltip} from 'react-bootstrap'

export default class RulesEditButton extends Component {
    render() {
        return (
            

            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 200, hide: 200 }}
                    overlay={<Tooltip style={{fontFamily:'SFUIDisplay',fontSize:'12px'}}>ویرایش</Tooltip>}
                >
                    <div style={{cursor:'pointer',userSelect:'none'}} onClick={() => this.props.editItem(this.props.value)}>
                        <img src={Edit} alt="" style={{objectFit: 'contain',height:'18px'}} />
                    </div>
                </OverlayTrigger>
                
            </div>
        )
    }
}
